import { z } from 'zod'

import { Pagination } from 'app/types/app/request'
import { Client } from 'app/types/park/client'

/** Service related to a konvive user to get an employer contribution. */
export const Service = z.object({
    /** ID of the service. */
    id: z.number().positive(),

    /** Name of the service. */
    name: z.string().min(1),

    /** Client related to the service. */
    client: Client,

    /** The domain name related to the service. */
    domain_name: z.string().nullable(),
})

export type Service = z.infer<typeof Service>

export const ServiceBinding = Service.pick({
    id: true,
    name: true,
})

export type ServiceBinding = z.infer<typeof ServiceBinding>

export const ServicesRequest = Pagination.extend({
    results: Service.array(),
})

export type ServicesRequest = z.infer<typeof ServicesRequest>

/** Service payload to create or update a service. */
export const ServicePayload = Service.omit({
    id: true,
}).extend({
    client: Client.shape.id,
})

export type ServicePayload = z.infer<typeof ServicePayload>
